"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCapitalCase = void 0;
/**
 * @summary Converts a string to `CAPITAL_CASE`.
 *
 * Converts a string to `CAPITAL_CASE`.
 *
 * @param {string} str
 * @returns {string}
 *
 * @example
 * const key = toCapitalCase('my-identifier');
 */
function toCapitalCase(str) {
    return str
        .trim()
        .replace(/[^\w]/g, '_')
        .replace(/([a-z])([A-Z])/g, '$1_$2')
        .replace(/_+/g, '_')
        .toUpperCase();
}
exports.toCapitalCase = toCapitalCase;
